// removed by extract-text-webpack-plugin
module.exports = {"page":"_3evj-8ReY _2l0xl0HVf m_MD8dOe5 kthKJ-hIO M02IhxSCi","tab-container":"_3nLxxeH2k _2l0xl0HVf _2cxE75SKM _8QSagsfVR _252nX0Tjy","emptyEvents":"_1etgbvyy4 _2l0xl0HVf _1yJuXbiru _1N1LPNKhM _1yThnDgzj _1BE2U7F8v _2AKkwhco3 aokgWzHRc _1OqJ1vEYi _2tvY6e7Hw _2BH_6_kaD _3X0ob54cP _23s7Mrdy_ iNGToVUbh","emptyPastEvents":"qUglpj1h4 _1etgbvyy4 _2l0xl0HVf _1yJuXbiru _1N1LPNKhM _1yThnDgzj _1BE2U7F8v _2AKkwhco3 aokgWzHRc _1OqJ1vEYi _2tvY6e7Hw _2BH_6_kaD _3X0ob54cP _23s7Mrdy_ iNGToVUbh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/event-group-home-page/event-group-home-page.css
 ** module id = 2188
 ** module chunks = 0
 **/